import React, { useContext } from 'react';
import { AppContext } from '../../App';
import { Search, TrendingUp, TrendingDown } from 'lucide-react';

const TrendingSearches = () => {
  const { dashboardData } = useContext(AppContext);
  
  if (!dashboardData) return null;
  
  const { search_trends } = dashboardData;

  const getCategoryColor = (category) => {
    const colors = {
      'model': '#3B82F6',
      'body_type': '#F97316',
      'feature': '#22C55E',
      'price_range': '#A855F7',
      'make': '#EC4899'
    };
    return colors[category] || '#A1A1AA';
  };

  // Sort by volume
  const sortedTrends = [...search_trends].sort((a, b) => b.volume - a.volume);
  const maxVolume = Math.max(...sortedTrends.map(t => t.volume));

  return (
    <div className="dashboard-card p-6" data-testid="trending-searches">
      <div className="flex items-center gap-3 mb-6">
        <div className="p-2 bg-[#EC4899]/10 rounded-lg">
          <Search className="w-5 h-5 text-[#EC4899]" />
        </div>
        <div>
          <h3 className="text-lg font-bold text-white">Trending Searches</h3>
          <p className="text-sm text-[#A1A1AA]">What buyers are looking for</p>
        </div>
      </div>

      {/* Category Legend */}
      <div className="flex flex-wrap gap-3 mb-4 pb-4 border-b border-[#27272A]">
        {['model', 'body_type', 'feature', 'price_range'].map(cat => (
          <div key={cat} className="flex items-center gap-2 text-xs">
            <div 
              className="w-2 h-2 rounded"
              style={{ backgroundColor: getCategoryColor(cat) }}
            />
            <span className="text-[#A1A1AA] capitalize">{cat.replace('_', ' ')}</span>
          </div>
        ))}
      </div>

      {/* Trends List */}
      <div className="space-y-3">
        {sortedTrends.slice(0, 10).map((trend, index) => {
          const barWidth = (trend.volume / maxVolume) * 100;
          const color = getCategoryColor(trend.category);
          
          return (
            <div 
              key={index}
              className="group"
              data-testid={`trend-${index}`}
            >
              <div className="flex items-center justify-between mb-1">
                <div className="flex items-center gap-2">
                  <span className="text-xs text-[#52525B] w-4">{index + 1}</span>
                  <span className="text-sm text-white group-hover:text-[#3B82F6] transition-colors">
                    {trend.term}
                  </span>
                </div>
                <div className="flex items-center gap-2">
                  <span className={`flex items-center gap-1 text-xs ${
                    trend.change >= 0 ? 'text-[#22C55E]' : 'text-[#EF4444]'
                  }`}>
                    {trend.change >= 0 ? <TrendingUp className="w-3 h-3" /> : <TrendingDown className="w-3 h-3" />}
                    {Math.abs(trend.change)}%
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="flex-1 h-2 bg-[#27272A] rounded-full overflow-hidden">
                  <div 
                    className="h-full rounded-full transition-all duration-500"
                    style={{ width: `${barWidth}%`, backgroundColor: color }}
                  />
                </div>
                <span className="text-xs text-[#A1A1AA] font-mono w-12 text-right">
                  {(trend.volume / 1000).toFixed(1)}K
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TrendingSearches;
